/**
 * Typed error surface for the backend 403 `plan_required` contract.
 *
 * `apiClient.request` parses a 403 response body and, when the body matches
 * `{ error: "plan_required", required_plan: string, detail: string }`, throws
 * a `PlanRequiredError` so callers can branch on `instanceof PlanRequiredError`
 * without re-deriving the shape from string-matching.
 *
 * The class mirrors the lightweight `AuthError` pattern in
 * `modules/authentication/types/form-login-types.tsx`: no extra dependencies,
 * `name` set explicitly, prototype chain restored for `instanceof` across
 * transpilers, no custom toString.
 */
export type PlanRequiredBody = {
    error: string;
    required_plan: string;
    detail: string;
};

export class PlanRequiredError extends Error {
    public readonly required_plan: string;
    public readonly body: PlanRequiredBody;

    constructor(body: PlanRequiredBody) {
        super(`Plan required: ${body.detail}`);
        this.name = "PlanRequiredError";
        this.required_plan = body.required_plan;
        this.body = body;
        Object.setPrototypeOf(this, PlanRequiredError.prototype);
    }
}
